import axios from "axios";
import { localStorageVar } from "../constant";
import { DataEncription, Decrypt } from "../services/data-encription";
import { getFromLocalStorage, removeFromLocalStorage } from "../hooks/useLocalStorage";
import createFilterData from "../utilities/createFilterData";
import { toast } from "react-toastify";
import { store } from "../store";
import { logoutSession } from "../redux/common/action";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
//import { autoSpell } from "./utiles";
export const fetchProductApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/product.json`);
};

export const fetchChatApi1 = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/chatMember.json`);
};

export const fetchChatApi2 = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/chat.chats.json`);
};

export const fetchEmailApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/email.json`);
};

export const fetchBookmaekApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/bookmark.json`);
};

export const fetchTodoApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/todo.json`);
};

export const fetchTaskApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/task.json`);
};

export const fetchProjectApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/project.json`);
};

// EPORTAL 2.0
export const fetchAllUsersDataApi = () => {
    return axios.get(`${process.env.PUBLIC_URL}/api/project.json`);
};

// CUSTUM USE
export const middlewareEncryption = async (api, data = {}, head = true, multiMediaHeaders = false, isLogoutTrigger = false) => {
    console.log('Payload:', data);

    try {
        if (head) {
            const token = localStorage.getItem("token")
            let headers
            if (multiMediaHeaders) {
                headers = {
                    'Authorization': token,
                    'Content-Type': 'multipart/form-data',
                    // 'Current-Role': localStorage.getItem("ROLE") ? JSON.stringify(localStorage.getItem("ROLE")) : ''
                }
                let result = await axios.post(`${process.env.REACT_APP_SERVER_URL}${api}`, data, { headers })
                return result
            } else {
                headers = {
                    'Authorization': token,
                    // 'Current-Role': localStorage.getItem("ROLE") ? JSON.stringify(localStorage.getItem("ROLE")) : ''
                }
                let result = await axios.post(`${process.env.REACT_APP_SERVER_URL}${api}`, DataEncription(data), { headers });
                console.log(result?.data, "result?.data?.result")
                if (result?.data?.result) {
                    result.data.result = Decrypt(result.data.result)
                }
                if (process.env.NODE_ENV?.toLowerCase() == "development") {
                    console.log(result.data.result, "result-data")
                }
                return result
            }

        }
        else {
            let result = await axios.post(`${process.env.REACT_APP_SERVER_URL}${api}`, DataEncription(data));
            if ("result" in result.data) {
                result.data.result = Decrypt(result.data.result)
            }
            if (process.env.NODE_ENV?.toLowerCase() == "development") {
                console.log(result, "result2")
            }
            return result
        }
    } catch (error) {
        if (!isLogoutTrigger) {
            if (error.response?.status == 401) {

                if (error.response?.data?.error == "Your session has expired, please try logging in again.") {
                    clientLogout(null, true);
                }
            }
            // if (error.response?.status == 500) {

            //     // toast.error("Something went wrong")
            //     // console.log(error.response?.data?.error,"500 error status code error message")
            //     // window.location.href = '/dashboard/default';
            //     return
            // }
            // else {
            if (error.response?.data) {
                if ("result" in error.response?.data) {
                    error.response.data.result = Decrypt(error.response.data.result)
                }
            }

            throw error;
            // }
        } else {
            clientLogout(null);
        }

    }
}

export const middlewareDecryption = async (api, type = "API") => {
    try {
        const token = localStorage.getItem("token");
        const headers = {
            'Authorization': token
        };
        let result = await axios.get(`${process.env.REACT_APP_SERVER_URL}${api}`, { headers });
        if ("result" in result.data) {
            result.data.result = Decrypt(result.data.result);
        }
        if (process.env.NODE_ENV?.toLowerCase() == "development") {
            console.log(result, "result")
        }
        return result;
    } catch (error) {
        // debugger
        if (error.response?.status == 401) {
            // const navigate = useNavigate();

            if (error.response?.data?.error == "Your session has expired, please try logging in again.") {
                clientLogout(null, true);
            }
            let sessionErrorMessage
            if (error.response?.data?.error) {
                sessionErrorMessage = error.response.data.error;
            } else {
                sessionErrorMessage = "Session time out";
            }

            localStorage.setItem("sessionErrorMessage", sessionErrorMessage);
            // const { performLogoutAction } = ReduxCtmDispatch();
            // performLogoutAction()




            //window.location.href = `${process.env.PUBLIC_URL}/pages/errors/error401`;
        } else {
            throw error;
        }
        // else if (error.response?.status == 500) {
        //     toast.error("Something went wrong")
        //     console.log(error.response?.data?.error,"500 error status code error message")
        //     window.location.href = '/dashboard/default';
        //     return
        // }

    }
}

export const middlewareDecryptionWithoutToken = async (api, data = {}) => {
    try {
        let result = await axios.get(`${process.env.REACT_APP_SERVER_URL}${api}`, DataEncription(data));
        console.log('result', result)
        if (process.env.NODE_ENV?.toLowerCase() == "development") {
            console.log(result, "result2")
        }
        return result
    } catch (error) {
        if (error.response?.status == 401) {
            // const navigate = useNavigate();

            if (error.response?.data?.error == "Your session has expired, please try logging in again.") {
                clientLogout(null, true);
            }
            let sessionErrorMessage
            if (error.response?.data?.error) {
                sessionErrorMessage = error.response.data.error;
            } else {
                sessionErrorMessage = "Session time out";
            }

            localStorage.setItem("sessionErrorMessage", sessionErrorMessage);
            // const { performLogoutAction } = ReduxCtmDispatch();
            // performLogoutAction()




            //window.location.href = `${process.env.PUBLIC_URL}/pages/errors/error401`;
        } else {
            throw error;
        }
        // else if (error.response?.status == 500) {
        //     toast.error("Something went wrong")
        //     console.log(error.response?.data?.error,"500 error status code error message")
        //     window.location.href = '/dashboard/default';
        //     return
        // }

    }
}


export const clientLogout = async (navigate, isSessionTimeOut = false) => {
    if (isSessionTimeOut) {
        Swal.fire({
            icon: 'info',
            title: 'Session timed out'
        });
    }
    await store.dispatch(logoutSession())

    let user = localStorage.getItem("user");
    let browserId = localStorage.getItem("browserId");
    let isRememberMe = localStorage.getItem("isRememberMe");
    let sessionErrorMessage = localStorage.getItem("sessionErrorMessage");

    // Clear local storage
    // localStorage.clear();
    removeFromLocalStorage(localStorageVar.USER_VAR)
    removeFromLocalStorage(localStorageVar.TOKEN_VAR)

    localStorage.setItem("sessionErrorMessage", sessionErrorMessage);

    if (isRememberMe == "true") {
        localStorage.setItem("user", user);
        localStorage.setItem("browserId", browserId);
        localStorage.setItem("isRememberMe", isRememberMe);
        if (navigate) {
            navigate(`${process.env.PUBLIC_URL}/rememberMe`);
        } else {
            window.location.href = `${process.env.PUBLIC_URL}/rememberMe`;
        }
    }
    else {
        if (navigate) {
            navigate(`${process.env.PUBLIC_URL}/login`);
        } else {
            // setTimeout(() => {
            window.location.href = `${process.env.PUBLIC_URL}/login`;
            // }, 3000);
            // window.location.href = `${process.env.PUBLIC_URL}/login`;
        }
    }
}


export const userLogin = async (data) => {
    return middlewareEncryption("/api/users/login", data, false)
};

export const getUnreadNotifications = () => {
    return middlewareDecryption("/api/notifications/unread");
};

export const getAllNotifications = (page = 1, limit = 50) => {
    return middlewareDecryption(`/api/notifications/all?page=${page}&limit=${limit}`);
};

export const markNotificationRead = (notification_ids) => {
    return middlewareEncryption("/api/notifications/markRead", { notification_ids });
};


export const requestResetPassword = (data) => {
    return middlewareEncryption("/api/users/requestResetPassword", data, false)
};

export const consumeResetPassword = (data) => {
    return middlewareEncryption("/api/users/consumeResetPassword", data, false)
};

export const checkValidToken = (data) => {
    return axios.get(`${process.env.REACT_APP_SERVER_URL}/api/users/checkValidToken/${data}`);
};

export const VerifyEmailOtp = (data) => {
    return middlewareEncryption("/api/users/consumeVerifyEmailOtp", data, false)
};

export const VerifyPhoneOtp = (data) => {
    return middlewareEncryption("/api/users/consumeVerifyPhoneOtp", data, false)
};
export const LoginOtp = (data) => {
    return middlewareEncryption("/api/users/consumeLogInOtp", data, false)
};

export const resendPhoneVerificationOtp = (data) => {
    return middlewareEncryption("/api/users/resendPhoneVerificationOtp", data, false)
};

export const resendEmailVerificationOtp = (data) => {
    return middlewareEncryption("/api/users/resendEmailVerificationOtp", data, false)
};

export const resendLoginEmailOtp = (data) => {
    return middlewareEncryption("/api/users/resendLoginEmailOtp", data, false)
};

export const changePasswordApi = (data) => {
    return middlewareEncryption("/api/users/changePassword", data)
};

export const getProfile = () => {
    return middlewareDecryption(`/api/users/getProfile`);
};

export const updateProfile = (data) => {
    return middlewareEncryption("/api/users/updateProfile", data)
};

export const logoutUser = async (navigate) => {
    let data = {
        "type": "all"
    }
    await middlewareEncryption("/api/users/logOut", data, true, false, true).then((res) => {
        if (res.data?.code == 200) {

            clientLogout(navigate);
        }
    })

};

export const remember = (data) => {
    return middlewareEncryption("/api/users/rememberMe", data)
};
export const rememberPassword = () => {

    const token = JSON.parse(localStorage.getItem("user"));
    const browser_id = localStorage.getItem("browserId");
    let data = {
        "email": token.email,
        "browser_id": browser_id
    }
    return axios.post(`${process.env.REACT_APP_SERVER_URL}/api/users/RememberedLogin`, DataEncription(data))
};

export const clearRememberMe = () => {
    const token = JSON.parse(localStorage.getItem("user"));
    const browser_id = localStorage.getItem("browserId");
    let data = {
        "email": token.email,
        "browser_id": browser_id
    }
    return middlewareEncryption("/api/users/clearRememberedLogin", data)
};

export const creatNewUser = (data) => {
    return middlewareEncryption("/api/admin/createUser", data)
};
export const getAllUser = (page, rowsPerPage, searchText, columnFilters, sorting, dataType) => {

    const filterNew = JSON.stringify(columnFilters ?? []);
    const sortingConv = JSON.stringify(sorting ?? []);
    if (page == undefined || rowsPerPage == undefined) {
        return middlewareDecryption(`/api/admin/getAlluser`)
    }
    return middlewareDecryption(`/api/admin/getAlluser?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filterList=${filterNew}&sort=${sortingConv}&dataType=${dataType}`)
};
export const getUsersDetailsByRole = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    if (!role_id) {
        return toast.error('Role missing in route');
    }
    // if(page == undefined || rowsPerPage == undefined){
    //     return middlewareEncryption(`/api/dealership/getUsersDetailsByRole/${role_id}`, {data})
    // }
    // const queryParameters = new URLSearchParams(window.location.search)
    // const type = queryParameters.get("type")
    // const name = queryParameters.get("name")


    // flag for user list 
    // admin - 1, ccm-2, 3-dm, dsp

    // if(role_id = 9){}
    let dataType = 1;

    // Get the current URL from the browser
    const currentURL = window.location.href;

    // Check if the URL contains '/dealership/users' or '/dealership/company' and set dataType accordingly
    if (currentURL.includes('/affiliations/partnership/users')) {
        dataType = 3;
    } else if (currentURL.includes('/affiliations/companies/users')) {
        dataType = 2;
    }


    const data = createFilterData(columnFilters, page, rowsPerPage);

    data.adminFLAG = dataType;

    return middlewareEncryption(`/api/dealership/getUsersDetailsByRole/${role_id}`, data)
};
export const getUserbyId = (id) => {
    return middlewareDecryption(`/api/admin/getuserById/${id}`);

};
export const editUser = (id, data) => {
    return middlewareEncryption(`/api/admin/editUser/${id}`, data)
};

export const getAllLower = (id) => {
    return middlewareDecryption(`/api/users/getAllLower/${id}`);
};

export const changeStatus = (id, data) => {
    return middlewareEncryption(`/api/admin/changeStatus/${id}`, data)
};

//Role API
export const creatNewRole = (data) => {
    return middlewareEncryption("/api/admin/createRole", data)
};

export const getAllRole = (type = "API") => {
    return middlewareDecryption(`/api/admin/getAllRole`, type);
};

export const getRoleById = (id) => {
    return middlewareDecryption(`/api/admin/getRoleById/${id}`);

};
export const editRole = (id, data) => {
    return middlewareEncryption(`/api/admin/updateRole/${id}`, data)
};

export const activteRoles = (id, data) => {
    return middlewareEncryption(`/api/admin/activateRole/${id}`, data)

};

export const deleteRoles = (id, data) => {
    return middlewareEncryption(`/api/admin/deleteRole/${id}`, data)
};

//permission
export const creatNewPermission = (data) => {
    return middlewareEncryption("/api/admin/createPermission", data)
};

export const getAllPermission = () => {
    return middlewareDecryption(`/api/admin/getAllPermission`);
};

export const getPermissionsById = (id) => {
    return middlewareDecryption(`/api/admin/getPermissionById/${id}`);
};

export const editPermission = (id, data) => {
    return middlewareEncryption(`/api/admin/updatePermission/${id}`, data)
};

export const deletePermissions = (id, data) => {
    return middlewareEncryption(`/api/admin/deletePermission/${id}`, data)
};

export const activatePermissions = (id, data) => {
    return middlewareEncryption(`/api/admin/activatePermission/${id}`, data)
};
export const deactivatePermissions = (id, data) => {
    return middlewareEncryption(`/api/admin/deactivatePermission/${id}`, data)
};

//RoleHasPermissions
export const creatNewroleHaspermissions = (data) => {
    return middlewareEncryption("/api/admin/createRoleHasPermission", data)
};

export const getAllRoleHasPermission = () => {
    return middlewareDecryption(`/api/admin/getAllRoleHasPermission`);
};

export const getRoleHasPermissionById = (id) => {
    return middlewareDecryption(`/api/admin/getRoleHasPermissionById/${id}`);
};

export const editRoleHasPermission = (id, data) => {
    return middlewareEncryption(`/api/admin/updateRoleHasPermission/${id}`, data)
};

export const deleteRoleHasPermissions = (id, data) => {
    return middlewareEncryption(`/api/admin/deleteRoleHasPermission/${id}`, data)
};

export const activateRoleHasPermissions = (id, data) => {
    return middlewareEncryption(`/api/admin/activateRoleHasPermission/${id}`, data)
};

//UserHasRole
export const creatNewUserHasRole = (data) => {
    return middlewareEncryption("/api/admin/createuserHasRole", data)
};

export const getUserHasRoleById = (id) => {
    return middlewareDecryption(`/api/admin/getuserHasRoleById/${id}`);
};

export const UpdateUserHasRole = (id, data) => {
    return middlewareEncryption(`/api/admin/updateUserHasRole/${id}`, data)
};

export const deleteUserHasRole = (id, data) => {
    return middlewareEncryption(`/api/admin/deleteuserHasRole/${id}`, data)
};
export const activateUserHasRole = (id) => {
    return middlewareDecryption(`/api/admin/activateuserHasRole/${id}`);
};

//logs



export const getAllError = (page) => {
    return middlewareDecryption(`/api/admin/getAllActivity?type=error&pageNo=${page}`);
};
export const getAllActivity = (page) => {

    return middlewareDecryption(`/api/admin/getAllActivity?type=activity&pageNo=${page}`);
};
export const getAllPolicyElastic = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    let data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/admin/getAllPolicyElastic`, data);
};
export const getAllActivityCron = (id) => {
    return middlewareDecryption(`/api/admin/getAllActivity?type=cron&pageNo=${id}`);
};
export const getAllApi = (id) => {
    return middlewareDecryption(`/api/admin/getAllActivity?type=api&pageNo=${id}`);
};
//sales
export const creatNewCategory = (data) => {
    return middlewareEncryption("/api/sales/addCategory", data)
};

export const getAllCategories = () => {
    return middlewareDecryption(`/api/sales/getAllCategory`);
};

// Active Categories only
export const getAllCategory = () => {
    return middlewareDecryption(`/api/sales/getActiveCategory`);
};

export const getCategoryById = (id) => {
    return middlewareDecryption(`/api/sales/getCategoryById/${id}`);
};

export const getCategoryByBrandId = (id) => {
    return middlewareDecryption(`/api/affiliation/getcategoryByBrandID/${id}`);
};
export const getProductBySaleDateAndCategory = (data) => {
    return middlewareEncryption(`/api/product/getProductToSale`, data);
};
export const getProductDetails = (data) => {
    return middlewareEncryption(`/api/product/getProductTax`, data);
};

export const editCategory = (id, data) => {
    return middlewareEncryption(`/api/sales/updateCategory/${id}`, data)
};
export const deleteCategories = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/sales/deleteCategory/${id}`, { headers });
};
export const activateCategory = (id) => {
    return middlewareDecryption(`/api/sales/activateCategory/${id}`)
};
// export const getCompanyByCategoryId = (id) => {
//      let data;
//     const COMPANY_MODULE = getFromLocalStorage("user")?.companyInfo?.module_id;
//     data.module_id = COMPANY_MODULE;
//     console.log("inside getcompnay",COMPANY_MODULE)
//     return middlewareEncryption(`/api/sales/getCompanyByCategoryId/${id}`,data)
// };

export const getCompanyByCategoryId = (id) => {
    const data = {};
    const COMPANY_MODULE = getFromLocalStorage("user")?.companyInfo?.module_id;
    data.module_id = COMPANY_MODULE;
    return middlewareDecryption(`/api/sales/getCompanyByCategoryId/${id}`, data)
};



export const getCompanyByCategoryIdWithPlan = (id) => {
    return middlewareDecryption(`/api/sales/getCompanyByCategoryIdWithPlan/${id}`)
};

export const getCompanyByCategoryIdWithPlanNew = (id, data) => {
    return middlewareEncryption(`/api/sales/getCompanyByCategoryIdWithPlan/${id}`, data)
};



//Service
export const creatNewService = (data) => {
    return middlewareEncryption("/api/sales/addService", data)
};

// export const getAllService = (page, rowsPerPage, searchText, filterList, sortOrder) => {
//     return middlewareDecryption(`/api/sales/getAllService?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterList}&sort=${sortOrder}`);

// };

export const getAllService = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const filterNew = JSON.stringify(columnFilters ?? []);
    const sortingConv = JSON.stringify(sorting ?? []);
    if (page === undefined || rowsPerPage === undefined) {
        return middlewareDecryption(`/api/sales/getAllService`)
    }
    return middlewareDecryption(`/api/sales/getAllService?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText || ""}&filter=${filterNew}&sort=${sortingConv}`)
};
export const deleteServices = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/sales/deleteService/${id}`, { headers });
};

export const getServiceById = (id) => {
    return middlewareDecryption(`/api/sales/getServiceById/${id}`);
};

export const editServices = (id, data) => {
    return middlewareEncryption(`/api/sales/updateService/${id}`, data)
};

export const activateService = (id) => {
    return middlewareDecryption(`/api/sales/activateService/${id}`);
};

//Taxes
export const creatNewTax = (data) => {
    return middlewareEncryption("/api/sales/addTax", data)
};

export const getAllParentTax = () => {
    return middlewareDecryption(`/api/sales/getAllTax`);
};

export const getTaxById = (id) => {
    return middlewareDecryption(`/api/sales/getTaxById/${id}`);
};

export const activateParentTax = (id) => {
    return middlewareDecryption(`/api/sales/activateTax/${id}`);
};

export const updateParentTax = (id, data) => {
    return middlewareEncryption(`/api/sales/updateTax/${id}`, data)
};

// coupons

export const creatNewCoupon = (data) => {
    return middlewareEncryption("/api/sales/addCoupon", data)
};

export const getAllCoupons = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    // return middlewareDecryption(`/api/sales/getAllCoupon`);
    const filterNew = JSON.stringify(columnFilters ?? []);
    const sortingConv = JSON.stringify(sorting ?? []);
    if (page === undefined || rowsPerPage === undefined) {
        return middlewareDecryption(`/api/sales/getAllCoupon`)
    }
    return middlewareDecryption(`/api/sales/getAllCoupon?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterNew}&sort=${sortingConv}`)
};

export const getCouponById = (id) => {
    return middlewareDecryption(`/api/sales/getCouponById/${id}`);
};

export const editCoupon = (id, data) => {
    return middlewareEncryption(`/api/sales/updateCoupon/${id}`, data)
};


export const deleteCoupon = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/sales/deleteCoupon/${id}`, { headers });
};

export const activateCoupon = (id) => {
    return middlewareDecryption(`/api/sales/activateCoupon/${id}`);
};
//Brand 
export const getAllBrand = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAllBrand`, data)
};
export const getActiveBrand = () => {
    return middlewareDecryption(`/api/affiliation/getBrandList`)
};
export const creatNewBrand = (data) => {
    return middlewareEncryption("/api/affiliation/addBrand", data)
};
export const creatNewCountry = (data) => {
    return middlewareEncryption("/api/affiliation/addBrand", data)
};
export const getBrandById = (id) => {
    return middlewareDecryption(`/api/affiliation/getBrandById/${id}`);
};

export const editBrand = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateBrand/${id}`, data)
};

export const deleteBrand = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteBrand/${id}`, { headers });
};

export const activateBrand = (id,) => {

    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateBrand/${id}`, {}, { headers });
};
//fuel


export const creatNewFuel = (data) => {
    return middlewareEncryption("/api/affiliation/addFuel", data)
};

// export const getAllFuel = (page, rowsPerPage, searchText, columnFilters, sorting) => {

//     if(!page || !rowsPerPage){
//         return middlewareDecryption(`/api/affiliation/getAllFuel`)
//     }

//     const filterNew  = JSON.stringify(columnFilters ?? []);
//     const sortingConv  = JSON.stringify(sorting ?? []);
//     if(page == undefined || rowsPerPage == undefined){
//         return middlewareDecryption(`/api/affiliation/getAllFuel`)
//     }
//     return middlewareDecryption(`/api/affiliation/getAllFuel?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterNew}&sort=${sortingConv}`)
// };

export const getAllFuel = (page, rowsPerPage, searchText, columnFilters, sorting) => {

    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAllFuel`, data)
};

export const getFuelById = (id) => {
    return middlewareDecryption(`/api/affiliation/getFuelById/${id}`);
};
export const getFuelByBrandId = (id) => {
    return middlewareDecryption(`/api/affiliation/getFuelByBrandId/${id}`);
};

export const editFuel = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateFuel/${id}`, data)
};
export const deleteFuels = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteFuel/${id}`, { headers });
};
export const activateFuel = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateFuel/${id}`, {}, { headers });
};

//Transmission
export const creatNewTransmission = (data) => {
    return middlewareEncryption(`/api/affiliation/addTransmission`, data)
};

// export const getAllTransmissin = (page, rowsPerPage, searchText, columnFilters, sorting) => {
//     // return middlewareDecryption(`/api/affiliation/getAllTransmission`);
//     const filterNew  = JSON.stringify(columnFilters ?? []);
//     const sortingConv  = JSON.stringify(sorting ?? []);
//     if(page == undefined || rowsPerPage == undefined){
//         return middlewareDecryption(`/api/affiliation/getAllTransmission`)
//     }
//     return middlewareDecryption(`/api/affiliation/getAllTransmission?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterNew}&sort=${sortingConv}`)
// };

export const getAllTransmissin = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAllTransmission`, data)
};

export const getTransmissionById = (id) => {
    return middlewareDecryption(`/api/affiliation/getTransmissionById/${id}`);
};
export const getTransmissionByBrandId = (id) => {
    return middlewareDecryption(`/api/affiliation/getTransmissionByBrandId/${id}`);
};

export const ediTransmissoin = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateTransmission/${id}`, data)
};
export const deleteTransmission = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteTransmission/${id}`, { headers });
};
export const activateTransmission = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateTransmission/${id}`, {}, { headers });
};

//Model
export const creatNewModel = (data) => {
    return middlewareEncryption(`/api/affiliation/addModel`, data)
};

export const getAllModel = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    // return middlewareDecryption(`/api/affiliation/getAllModel`);
    const data = createFilterData(columnFilters, page, rowsPerPage);

    return middlewareEncryption(`/api/affiliation/getAllModel`, data)
};

export const getModelById = (id) => {
    return middlewareDecryption(`/api/affiliation/getModelById/${id}`);
};
export const getModelsByBrandById = (id) => {
    return middlewareDecryption(`/api/affiliation/getModelByBrandId/${id}`);
};

export const updateModel = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateModel/${id}`, data);
};
export const deleteModelS = (id) => {
    const token = localStorage.getItem("token");
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteModel/${id}`, { headers });
};
export const activateModel = (id) => {
    const token = localStorage.getItem("token");
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateModel/${id}`, {}, { headers });
};

//Variant
export const createNewVariant = (data) => {
    return middlewareEncryption(`/api/affiliation/addVariant`, data);
};

export const getAllVariant = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAllVariant`, data)

};

export const getVariantById = (id) => {
    return middlewareDecryption(`/api/affiliation/getVariantById/${id}`);
};
export const getVariantByModelId = (id) => {
    return middlewareDecryption(`/api/affiliation/getVariantByModelId/${id}`);
};

export const updateVariant = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateVariant/${id}`, data);
};
export const deleteVariants = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteVariant/${id}`, { headers });
};
export const activateVariant = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateVariant/${id}`, {}, { headers });
};
//client company
export const createNewCompany = (data) => {
    return middlewareEncryption("/api/affiliation/addCompany", data)
};

export const getAllCompanys1 = () => {
    return middlewareDecryption(`/api/affiliation/getAllCompany`);
};
export const getAllCompanys = () => {
    return middlewareDecryption(`/api/affiliation/getAllCompany`)
};
export const getActiveCompany = () => {
    return middlewareDecryption(`/api/affiliation/getActiveCompany`)
};
export const getGeographicalCoverByCompanyId = (id) => {
    return middlewareDecryption(`/api/affiliation/getGeographicalCoverByCompanyId/${id}`,)
};
export const getCompanyData = () => {
    return middlewareDecryption(`/api/affiliation/getCompanyData`)
};
export const getDealerData = () => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    return middlewareDecryption(`/api/affiliation/getDealerData/${role_id}`)
};
export const getUserData = () => {
    return middlewareDecryption(`/api/dealership/getUserData`)
};
export const getTotalDealers2 = () => {
    return middlewareDecryption(`/api/affiliation/getTotalDealers`)
};

export const getAllCompanyList = (page, rowsPerPage, searchText, columnFilters, sorting) => {

    // const filterNew  = JSON.stringify(columnFilters ?? []);
    // const sortingConv  = JSON.stringify(sorting ?? []);
    // if(page == undefined || rowsPerPage == undefined){
    //     return middlewareDecryption(`/api/affiliation/getAllCompanyList`)
    // }
    // return middlewareDecryption(`/api/affiliation/getAllCompanyList?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filterList=${filterNew}&sort=${sortingConv}`)
    let data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAllCompanyList`, data)


};

// getActiveCompany

export const getAllCompanyListActive = (page, rowsPerPage, searchText, columnFilters, sorting) => {

    const filterNew = JSON.stringify(columnFilters ?? []);
    const sortingConv = JSON.stringify(sorting ?? []);
    if (page === undefined || rowsPerPage === undefined) {
        return middlewareDecryption(`/api/affiliation/getActiveCompany`)
    }
    return middlewareDecryption(`/api/affiliation/getActiveCompany?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText || ""}&filterList=${filterNew}&sort=${sortingConv}`)

};

export const getCompanyById = (id) => {
    return middlewareDecryption(`/api/affiliation/getCompanyById/${id}`);
};

export const getbrandbycompanyid = (id) => {
    return middlewareDecryption(`/api/affiliation/getbrandbycompanyid/${id}`);
};

export const getClientConfigCompanyById = (id) => {
    return middlewareDecryption(`/api/sales/getClientConfigCompanyById/${id}`);
};

export const getClientConfig = (data) => {
    return middlewareEncryption(`/api/affiliation/getClientConfig`, data)
};

export const getMasterPincode = (data) => {
    return middlewareEncryption(`/api/affiliation/getMasterPincode`, data);
};

export const updateMasterPincode = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateMasterPincode/${id}`, data)
};

export const saveMasterPincode = (data) => {
    return middlewareEncryption(`/api/affiliation/saveMasterPincode`, data);
};

export const stateCityByActiveMasterPincode = (data) => {
    return middlewareEncryption(`/api/users/getDataByActiveMasterPincode`, data)
};


export const getcategoryBrandBycompanyId = (id) => {
    return middlewareDecryption(`/api/sales/getcategoryBrandBycompanyId/${id}`);
};

export const updateCompany = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateCompany/${id}`, data)
};

export const deleteCompany = (id) => {

    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteCompany/${id}`, { headers });
};

export const activateCompany = (id) => {
    // return middlewareDecryption(`/api/affiliation/activateCompany/${id}`);
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateCompany/${id}`, {}, { headers });
};

//client Dealer
export const createNewDealer = (data) => {
    return middlewareEncryption("/api/affiliation/addDealership", data)
};
export const bulkUploadDealer = (data) => {
    return middlewareEncryption("/api/affiliation/dealershipBulkUpload", data)
};
export const getAllDealers = (page, rowsPerPage, searchText, columnFilters, sorting) => {

    let data = createFilterData(columnFilters, page, rowsPerPage);

    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';

    return middlewareEncryption(`/api/affiliation/getDealershipBynew/` + role_id, data);
};
export const getDealerById = (id) => {
    return middlewareDecryption(`/api/partnership/getPartnerById/${id}`);
};

export const getGlobalFeatures = () => {
    return middlewareDecryption(`/api/partnership/features`);
};

export const createGlobalFeature = (data) => {
    return middlewareEncryption(`/api/partnership/features`, data);
};

export const getFeatureEnabledBps = (featureKey) => {
    return middlewareDecryption(`/api/partnership/features/${featureKey}/bps`);
};

export const getBpFeatures = (id) => {
    return middlewareDecryption(`/api/partnership/bps/${id}/features`);
};

export const upsertBpFeature = (id, data) => {
    return middlewareEncryption(`/api/partnership/bps/${id}/features`, data);
};

export const getBpFeatureLogs = (bpId, featureKey) => {
    return middlewareDecryption(`/api/partnership/bps/${bpId}/features/${featureKey}/logs`);
};

export const updateDealer = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateDealership/${id}`, data)
};

export const deleteDealer = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteDealership/${id}`, { headers });
};

export const activateDealer = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateDealership/${id}`, {}, { headers });
};

//Company user

export const createNewCompanyUser = (data) => {
    return middlewareEncryption(`/api/affiliation/addCompanyUser`, data)
};

//Dealership user
export const createNewDealershipUser = (data) => {
    return middlewareEncryption(`/api/affiliation/addDealershipUser`, data)
};
export const getDealerByCompanyId = (id) => {
    return middlewareDecryption(`/api/affiliation/getDealershipByCompanyId/${id}`);
};

// get external sync data
// export const getExternalSyncData = (data) => {
//     return middlewareEncryption(`/api/affiliation/getExternalSycnData`, data)
// }


export const getExternalSyncData = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption("/api/affiliation/getExternalSycnData", data)
};
// find by id 
export const createNewProduct = (data) => {
    // return middlewareEncryption("/api/product/addProduct", data)
    return middlewareEncryption("/api/affiliation/savePlanData", data)
};

//Product
export const getExternalSyncDataById = (data) => {
    // return middlewareEncryption("/api/product/addProduct", data)
    return middlewareEncryption("/api/affiliation/getExternalSycnDataById", data)
};

// Trigger resync for an external sync job
export const resyncExternalSync = (data) => {
    return middlewareEncryption("/api/affiliation/getExternalResync", data)
};

export const getAllProducts = () => {
    return middlewareDecryption(`/api/product/getAllProducts`);
};

export const getProductById = (id) => {
    return middlewareDecryption(`/api/product/getProductById/${id}`);
};

// export const getProductClientByClientId = (id) => {
//     return middlewareDecryption(`/api/product/getProductClientByClientId/${id}`);
// };

export const updateProduct = (id, data) => {
    return middlewareEncryption(`/api/product/updateProduct/${id}`, data)
};

export const activeDeactiveProduct = (data) => {
    return middlewareEncryption(`/api/affiliation/activeDeactiveProduct`, data)
};

export const downloadCostConstructByPlanId = (data) => {
    return middlewareEncryption(`/api/affiliation/downloadCostConstructByPlanId/${data.id}`, data)
};
export const deleteProduct = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/product/deleteProduct/${id}`, { headers });
};

export const activateProduct = (id) => {
    // const token = localStorage.getItem("token")
    // const headers = {
    //     'Authorization': token
    // };
    // return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/product/activateProduct/${id}`, {}, { headers });
    return middlewareEncryption(`/api/product/activateProduct/${id}`);
};


//wallet
export const getAllAdminWallet = (id) => {
    return middlewareDecryption(`/api/navision/getAllAdminWallet`);
};
export const getAllDealerWalletClosureInitiated = () => {
    return middlewareDecryption(`/api/dealership/listAllDealerWalletClosureInitiated`);
};

export const listAllDealerWalletStatus = () => {
    return middlewareDecryption(`/api/dealership/listAllDealerWalletStatus`);
};

export const getAllWalletRefund = (id) => {
    return middlewareDecryption(`/api/navision/getAllWalletRefund`);
};
export const getWalletBalance = (data) => {
    return middlewareEncryption(`/api/dealership/getWalletbalance`, data);
};

export const getWalleTransactions = (page, rowsPerPage, searchText, columnFilters, sorting) => {

    const user = JSON.parse(localStorage.getItem("user"));
    const id = user?.dealerInfo?.dealership_id ? user.dealerInfo?.dealership_id : '';
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getWalletHistoryByDealerId/${id}`, data);

};

export const getWalletHistoryByUserId = (page, rowsPerPage, searchText, columnFilters, sorting) => {

    const user = JSON.parse(localStorage.getItem("user"));
    const id = user?.user_id ? user.user_id : '';
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getWalletHistoryByUserId/${id}`, data);

};

export const getWalletHistoryByRoleId = (page, rowsPerPage, searchText, columnFilters, sorting) => {

    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const id = ROLE?.role_id ? ROLE.role_id : '';
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getWalletHistoryByRoleId/${id}`, data);

};


// export const getAllAdminWalletHistory = (data) => {
//     return middlewareEncryption(`/api/dealership/getAllAdminHistory`, data);
// };

export const getAllAdminWalletHistory = (data, page, rowsPerPage, searchText, columnFilters, sorting) => {
    const reqData = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getAllAdminHistory`, { ...data, ...reqData })
};

export const getAllAdminHistoryOnlyCredit = (data) => {
    return middlewareEncryption(`/api/dealership/getAllAdminHistoryOnlyCredit`, data);
};

export const walletClosureRequest = (id, data) => {
    return middlewareEncryption(`/api/dealership/initiateDealerWalletClosure/${id}`, data);
};
export const closeDealerWallet = (id, data) => {
    return middlewareEncryption(`/api/dealership/closeDealerWallet/${id}`, data);
};


//MY UserHasRole
export const getMyuserHasRole = () => {
    return middlewareDecryption(`/api/users/getMyuserHasRole`);
};


export const getAllCountry = () => {
    return middlewareDecryption(`/api/users/getAllCountry`)
}

export const getAllCountryAPI = () => {
    return middlewareDecryption(`/api/users/getAllCountryApi`)
}

export const getAllState = (id) => {
    return middlewareDecryption(`/api/users/getAllStateBYCountryId/${id}`)
}
export const getAllCity = (id) => {
    return middlewareDecryption(`/api/users/getAllcityByStateId/${id}`)
}


//report
export const CreateNewMisReport = (data) => {
    return middlewareEncryption(`/api/sales/getMisReport`, data);
};

//Add help desk
export const createNewHelDesk = (data) => {
    return middlewareEncryption("/api/users/addHelpDeskDocument", data)
};

export const updateHelpdesk = (id, data) => {
    return middlewareEncryption(`/api/users/editHelpDeskDocument/${id}`, data)
};


export const getAllHelpDeskFile = () => {
    return middlewareDecryption(`/api/users/getHelpDeskDocument`);
};

export const getAllActivityByRange = (data) => {
    return middlewareEncryption(`/api/admin/getAllActivityByRange`, data);
};




//


export const getProductClientByClientId = (id) => {
    return middlewareDecryption(`/api/product/getProductClientByClientIdNew/${id}`);
};

export const getAllProductClientByDealershipId = (id) => {
    return middlewareDecryption(`/api/product/getAllProductClientByDealershipId/${id}`);
};

export const getAssignedPlansByRole = (id, page, rowsPerPage, columnFilters) => {
    // return middlewareEncryption(`/api/product/getAssignedPlansByRole/${id}`);
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAssignedPlansByRole/${id}`, data);
};

export const getPartnershipPlanMsc = (data) => {
    return middlewareEncryption(`/api/affiliation/getPartnershipPlanMsc`, data);
};

export const getAssignedPlansByRoleWithoutPagination = (id, data) => {
    // return middlewareEncryption(`/api/product/getAssignedPlansByRole/${id}`);
    return middlewareEncryption(`/api/affiliation/getAssignedPlansByRole/${id}`, data);
};

export const assignProductClient = (data) => {
    return middlewareEncryption(`/api/product/assignProductClient`, data);
};

export const assignProductDealership = (data) => {
    return middlewareEncryption(`/api/product/assignProductDealership`, data);
};

export const getAllProductClient = (id) => {
    return middlewareDecryption(`/api/product/getAllProductClient`);
};

export const assignProductClientModelVariant = (data) => {
    return middlewareEncryption(`/api/product/assignProductClientModelVarient`, data);
};

export const assignProductClientModel = (data) => {
    return middlewareEncryption(`/api/product/assignProductClientModel`, data);
};

export const getModelByCompanyId = (id) => {
    return middlewareDecryption(`/api/affiliation/getModelByCompanyId/${id}`);
};

// export const getVariantByModelId = (id) => {
//     return middlewareDecryption(`/api/affiliation/getVariantByModelId/${id}`);
// };

// Sachin's Route
export const createNewUser = (data) => {
    return middlewareEncryption("/api/admin/createUser", data)
};

export const getPincodeDetails = (id, data) => {
    return middlewareDecryption(`/api/admin/getPincodeDetails/${id}`, data)
};

export const updateRoleOrder = () => {
    return 'success';
};

export const getServiceByCategoryId = (id) => {
    return middlewareDecryption(`/api/sales/getServiceByCategoryId/${id}`)
};

export const getAllProductList = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    // const filterNew  = JSON.stringify(columnFilters ?? []);
    // const sortString  = JSON.stringify(sorting ?? []);
    const data = createFilterData(columnFilters, page, rowsPerPage);

    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    // return middlewareDecryption(`/api/product/getAllProductList?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterNew}&sort=${sortString}`)
    return middlewareEncryption(`/api/product/getAllProductList/` + role_id, data)
};
// export const getAllPlanData = (page, rowsPerPage, searchText, columnFilters, sorting) => {
//     const filterNew  = JSON.stringify(columnFilters ?? []);
//     const sortString  = JSON.stringify(sorting ?? []);
//     const data = createFilterData(columnFilters, page, rowsPerPage);

//     const ROLE = JSON.parse(localStorage.getItem("ROLE"));
//     const role_id = ROLE?.role_id ? ROLE.role_id : '';
//     // return middlewareDecryption(`/api/product/getAllProductList?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterNew}&sort=${sortString}`)
//     return middlewareEncryption(`/api/affiliation/getAllPlanData/`+role_id, data)
// };

export const getAllProductData = () => {
    return middlewareDecryption(`/api/affiliation/getAllProductData`);
}

export const getAllPlanData = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAllPlanData`, data)
};

export const getAllCashifyProductList = (page, rowsPerPage, id, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/product/getAllCashifyProductList/2`, data)
};
export const getPlanDataById = (id) => {
    return middlewareDecryption(`/api/affiliation/getPlanDataById/${id}`)
};
export const getAllPlanDataWithoutFilter = (data) => {
    return middlewareEncryption(`/api/affiliation/getAllPlanData`, data)
};

export const getCashifyPlanDataById = (id) => {
    return middlewareDecryption(`/api/affiliation/getCashifyPlanDataById/${id}`)
};

export const editHelpDeskDocument = (id, data) => {
    return middlewareEncryption(`/api/users/editHelpDeskDocument/${id}`, data)
};
export const getHelpDeskDocumentByDealerId = (id) => {
    return middlewareDecryption(`/api/users/getHelpDeskDocumentByDealerId/${id}`)
};

export const getHelpDeskDocumentByCompanyRoleId = (id, secondId) => {
    return middlewareDecryption(`/api/users/getHelpDeskDocumentByCompanyRoleId/${id}/${secondId}`)
};


export const getAllPolicy = (page = 0, rowsPerPage = 10, searchText = "", columnFilters = [], sorting = []) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';

    // if(ROLE.key == 'DEALERSHIP_MANAGER' || ROLE.key == 'DEALER_SALES_PERSON'){
    //     return middlewareDecryption(`/api/dealership/getPolicyDetailsByDealer/`+user?.dealerInfo?.dealership_id);
    // }
    //  Aa of now we will keep it, we want all data in one api only, handle in backend by session

    // return middlewareDecryption(`/api/dealership/getPolicyDetailsByRole/`+ role_id +'?pageNo='+page+'&pageSize='+rowsPerPage);

    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getPolicyDetailsByRole/` + role_id, data);

};

export const getAllPolicy2 = (page = 0, rowsPerPage = 10, searchText = "", columnFilters = [], sorting = []) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getPolicyDetailsByRoleAssociated/` + role_id, data);

};

export const getPolicyDetailsByDealer = () => {
    return middlewareDecryption(`/api/dealership/getPolicyDetailsByDealer `);
};

export const getPolicyDetailsById = (id) => {
    return middlewareDecryption(`/api/dealership/getPolicyDetails/${id}`)
};

// export const getCashifyPolicyDetailsById = (id) => {
//     return middlewareEncryption(`/api/partnership/getCashifyPolicyDetails/${id}`)
// };

export const getCashifyPolicyDetailsById = (id) => {
    return middlewareDecryption(`/api/partnership/getCashifyPolicyDetails/${id}`)
};

export const bulkUploadPolicyInitiate = (data) => {
    return middlewareEncryption("/api/dealership/bulkUploadPolicyInitiate", data)
};
export const bulkUploadPolicy = (data) => {
    return middlewareEncryption("/api/dealership/saveBulkPolicy", data)
};

// export const addDMSDataByUrl = (data) => {
//     return middlewareEncryption("/api/affiliation/addDmsDataByURL", data,true,true)
// };
export const DMSDataCsvUpload = (data) => {
    return middlewareEncryption("/api/affiliation/addDmsDataByURL", data)
};


//session

export const getAllSessions = () => {
    return middlewareDecryption(`/api/users/getAllSessions`);
};

// export const deleteSessions = (id) => {
//     return middlewareEncryption(`/api/users/deleteSessions/${id}`)
// };

// export const deleteSessions = (data) => {
//     return middlewareEncryption("/api/users/deleteSessions", data)
// };

export const deleteSessions = (id) => {
    const data = {
        'id': id,
        "yek_ku76H6felco7": "#$x82kc6&m*E"
    };
    return axios.post(`${process.env.REACT_APP_SERVER_URL}/api/users/deleteSessions`, data);
}

//Dms Data
export const creatNewDms_data = (data) => {
    return middlewareEncryption("/api/affiliation/addDms_data", data)
};

export const getAllDms_data = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    // return middlewareDecryption(`/api/affiliation/getAllDms_data`);
    const filterNew = JSON.stringify(columnFilters ?? []);
    const sortingConv = JSON.stringify(sorting ?? []);
    if (page === undefined || rowsPerPage === undefined) {
        return middlewareDecryption(`/api/affiliation/getAllDms_data`)
    }
    return middlewareDecryption(`/api/affiliation/getAllDms_data?page=${page}&rowsPerPage=${rowsPerPage}&searchText=${searchText}&filter=${filterNew}&sort=${sortingConv}`)
};

export const getDms_dataById = (id) => {
    return middlewareDecryption(`/api/affiliation/getDms_dataById/${id}`);
};

export const editDms_data = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateDms_data/${id}`, data)
};
export const deleteDms_data = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteDms_data/${id}`, { headers });
};
export const activateDms_data = (id) => {
    const token = localStorage.getItem("token")
    const headers = {
        'Authorization': token
    };
    return axios.put(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/activateDms_data/${id}`, {}, { headers });

};

// Get all dms upload data list 

export const getDmsDataHistory = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getDmsDataHistory`, data);
};



// DMS list

export const getAllDmsData = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getAllDmsData`, data);
};

export const getDmsDataById = (id) => {
    return middlewareDecryption(`/api/affiliation/getDmsDataById/${id}`);
};


// Dashboard APIs
export const getGrandTotal = () => {
    // return middlewareDecryption(`/api/dealership/getGrandTotal`);
    return {};
    // return middlewareDecryption(`/api/dealership/getThisMonthDashBoard`);

};

export const getPolicyStatus = (data) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    // const role_id = ROLE?.role_id ? ROLE.role_id : '';
    // return middlewareEncryption(`/api/dealership/getdealerPolicyStatus/`+ role_id,{timeInterval:data});
    return {};
};

export const getPolicySales = (data) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareEncryption(`/api/dealership/getdealerPolicySales`, { role: key, timeInterval: data });
};

export const getClientWiseSales = (clientWiseSales, companyId) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareEncryption(`/api/dealership/getPolicySalesByClient`, { role: key, timeInterval: clientWiseSales, company_id: companyId });
};

export const getMyRequestData = (data) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareEncryption(`/api/dealership/getMyRequestByTimeInterval`, { role: key, timeInterval: data });
};

export const getDspPerformanceData = (dealership_id) => {
    return middlewareEncryption(`/api/dealership/getDspPerformanceWithPolicySales`, { dealership_id: dealership_id });
};

export const getTotalSystemUsers = () => {
    return middlewareDecryption(`/api/dealership/getTotalSystemUsers`);
};

export const getTotalDealers = (data) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareEncryption(`/api/dealership/getTotalDealers`, { role: key });
};

export const editPolicyDetails = (id, data) => {
    return middlewareEncryption(`/api/dealership/editPolicyDetails/${id}`, data);
};
export const forceDocumentEdit = (id, data) => {
    return middlewareEncryption(`/api/partnership/editDocument/${id}`, data);
};

export const SalesLedgerList = (data) => {
    return middlewareEncryption(`/api/partnership/getSalesLedgerListByRole`, data);
};

export const MscLedgerList = (data) => {
    return middlewareEncryption(`/api/partnership/getMscLedgerListByRole`, data);
};


export const getDealerRanking = (dealership_id) => {
    // return middlewareDecryption(`/api/dealership/getDealerRanking/`+ dealership_id);
    return {};

};

export const getPolicyExpirationData = (data) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareEncryption(`/api/dealership/getPolicyExpirationCount`, { role: key, timeInterval: data });
};

export const getAllDealerKycStatus = () => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const key = ROLE?.key ? ROLE.key : '';
    return middlewareDecryption(`/api/dealership/getAlldealerKycStatus`, { role: key });
};

// export const submitKyc = (data) => {
//     return middlewareEncryption("/api/dealership/submitKyc", data)
// };
export const submitKyc = (data) => {
    return middlewareEncryption("/api/partnership/submitKyc", data)
};

export const getKycDetailsByDealerId = (id) => {
    return middlewareDecryption(`/api/dealership/getKycDetailsByDealerId/${id}`);
};
// export const getDealerGrandTotal = () => {
//     return middlewareDecryption(`/api/dealership/getdealerTotal`);
// };

export const getDealerGrandTotal = (id) => {
    return middlewareDecryption(`/api/dealership/getdealerTotal/${id}`);
};


// Product list by client id
export const getProductByClientId = (id) => {
    return middlewareDecryption(`/api/product/getProductByClientId/${id}`);
};


export const getDealersTransactionByDate = (data) => {
    return middlewareEncryption("/api/admin/walletTransactionsByDate", data)
}

export const getPartnesTransactionByDate = (data) => {
    return middlewareEncryption("/api/admin/parnertswalletTransactionsByDate", data)

}

export const getCashifysTransactionByDate = (data) => {
    return middlewareEncryption("/api/admin/cashifyTrnsactionReport", data)
}


export const stateCityByPincode = (id) => {
    return middlewareDecryption(`/api/users/getDataByPincode/${id}`)
};

export const stateCityByActivePincode = (id) => {
    return middlewareDecryption(`/api/users/getDataByActivePincode/${id}`)
};

// Client configuration update or add
export const addOrUpdateClientConfiguration = (data) => {
    return middlewareEncryption(`/api/affiliation/addOrUpdateClientConfiguration`, data)
};
export const clientCompanyWithConfigurationByCompanyId = (id) => {
    return middlewareDecryption(`/api/affiliation/clientCompanyWithConfigurationByCompanyId/${id}`)
};

//training
//training-module
export const createTrainingModule = (data) => {
    return middlewareEncryption(`/api/training/createTraining`, data)
};

export const getAllTrainingModule = () => {
    return middlewareDecryption(`/api/training/getAllTrainingModule`);
};

export const getTrainingModuleByClientId = (id) => {
    return middlewareDecryption(`/api/training/getTrainingModuleByClientId/${id}`)
};
//ui pending from om
export const updateTrainingModule = (id, data) => {
    return middlewareEncryption(`/api/training/updateTrainingModule/${id}`, data)
};


//training-topic
export const addTopicByModuleId = (moduleId, data) => {
    return middlewareEncryption(`/api/training/addTopic/${moduleId}`, data)
};

export const getAllTrainingTopic = () => {
    return middlewareDecryption(`/api/training/getAllTrainingTopic`);
};

export const getTopicByModuleId = (id) => {
    return middlewareDecryption(`/api/training/getTopicByModuleId/${id}`)
};
export const updateTrainingTopic = (id, data) => {
    return middlewareEncryption(`/api/training/updateTrainingTopic/${id}`, data)
};


//training quiz

export const createTrainingQuiz = (data) => {
    return middlewareEncryption(`/api/training/createTrainingQuiz`, data)
};
export const getQuizByTopicId = (id, data) => {
    return middlewareEncryption(`/api/training/getQuizByTopicId/${id}`, data)
};

export const trainingQuizTest = (data) => {
    return middlewareEncryption(`/api/training/trainingQuizTest`, data)
};
export const trainingQuizResult = (data) => {
    return middlewareEncryption(`/api/training/trainingQuizResult`, data)
};

export const getAllQuiz = () => {
    return middlewareDecryption(`/api/training/getAllQuiz`);
};

export const updateTrainingQuiz = (id, data) => {
    return middlewareEncryption(`/api/training/updateTrainingQuiz/${id}`, data)
};

export const getQuizUserAnswersByTopicId = (id, data) => {
    return middlewareEncryption(`/api/training/getQuizUserAnswersByTopicId/${id}`, data)
};

// Ticketing system
export const getTickets = (payload, page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const combinedData = { ...payload, ...data, searchText, sorting };
    return middlewareEncryption(`/api/dealership/getTickets`, combinedData)
};
export const getTicketHistory = (id) => {
    return middlewareDecryption(`/api/dealership/getTicketHistory/${id}`,)
};
export const getTicketById = (id) => {
    return middlewareDecryption(`/api/dealership/getTicket/${id}`,)
};
export const getTicketHistoryByUserId = () => {
    return middlewareDecryption(`/api/dealership/getticketHistoryByUserId/`,)
};

// export const getTicketsByMe = () => {
//     return middlewareDecryption(`/api/dealership/getticketsByMe/`,)
// };
export const getTicketsByMe = (payload, page, rowsPerPage, searchText, columnFilters, sorting) => {

    // const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    // const role_id = ROLE?.role_id ? ROLE.role_id : '';
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const combinedData = { ...payload, ...data, searchText, sorting };
    return middlewareEncryption(`/api/dealership/getticketsByMe`, combinedData)
};
export const getAllTickets = (payload, page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const combinedData = { ...payload, ...data, searchText, sorting };
    return middlewareEncryption(`/api/dealership/getAllTickets`, combinedData)
};
export const getAllActionTicketsByMe = (payload, page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const combinedData = { ...payload, ...data, searchText, sorting };
    return middlewareEncryption(`/api/dealership/getMyActionTickets`, combinedData)
};
export const requestCancelPolicy = (id, data) => {
    return middlewareEncryption(`/api/dealership/requestCancelPolicy/${id}`, data)
};
export const requestWalletClosure = (id, data) => {
    return middlewareEncryption(`/api/dealership/initiateDealerWalletClosureTicketing/${id}`, data)
};

export const forcePolicyCancellation = (data) => {
    return middlewareEncryption(`/api/admin/forcePolicyCancellation`, data)
};
export const CashifyForcePolicyEdit = (id, data) => {
    return middlewareEncryption(`/api/admin/CashifyForcePolicyEdit/${id}`, data)
};

export const acceptOrRejectTicket = (data) => {
    return middlewareEncryption(`/api/dealership/acceptOrRejectTicket`, data)
};

export const deleteProductClientByClientId_ = (data) => {
    return middlewareEncryption(`/api/product/deleteProductClientByClientId_`, data)
};

export const deleteProductClientByDealershipId = (data) => {
    return middlewareEncryption(`/api/product/deleteProductClientByDealershipId`, data)
};

export const getMisReportByRange = (data) => {
    return middlewareEncryption(`/api/sales/getMisReportByRange`, data)
}

export const getMisReportByCompanyId = (data) => {
    return middlewareEncryption(`/api/sales/getMisReportByCompanyId`, data)
}
export const getAllCompanyMisReport = () => {
    return middlewareDecryption(`/api/sales/getAllCompanyMisReport`)
}
export const adminToWalletTransfer = (id, data) => {
    return middlewareEncryption(`/api/dealership/transferFromAdminTowallet/${id}`, data)
};

export const getDealershipByIdWithWalletInfo = (id) => {
    return middlewareDecryption(`/api/affiliation/getDealershipByIdWithWalletInfo/${id}`);
}
export const getAllProductClientModelVarient = (client_id) => {
    return middlewareDecryption(`/api/product/getAllProductClientModelVarient/` + client_id + `?sales_category_id=1`);
}
export const validatePanCard = (data) => {
    return middlewareEncryption(`/api/dealership/validatePanCard/`, data);
}
export const validateGstnByClearTax = (data) => {
    return middlewareEncryption(`/api/dealership/validateGstinCleartax/`, data);
}
export const requestPincodeToHO = (data) => {
    console.log("requestPincodeToHO data", data)
    return middlewareEncryption(`/api/dealership/requestPincodeToHO`, data);
}
export const validateGstnNumber = (data) => {
    return middlewareEncryption(`/api/dealership/validateGSTIN/`, data);
}
export const transferFromDealerToAdminWallet = (wallet_id, data) => {
    return middlewareEncryption(`/api/dealership/transferFromDealerToAdminWallet/` + wallet_id, data);
}

export const communicationHealth = () => {
    return middlewareDecryption(`/api/users/communicationHealth/`);
}
export const runCommunicationScript = () => {
    return middlewareEncryption(`/api/users/add-bulk-templates/`);
}
export const addProductSchedule = (data) => {
    return middlewareEncryption(`/api/product/addProductSchedule`, data)
};
export const getProductSchedule = (id) => {
    return middlewareDecryption(`/api/product/getProductSchedule/${id}`,)
};
export const getAllRefundTxnHistory = () => {
    return middlewareDecryption(`/api/dealership/getAllRefundTxnHistory`);
};
export const getCustomerDetails = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getCustomerDetails`, data);
};
export const getCompanyByCategories = (data) => {
    return middlewareDecryption(`/api/sales/getCompanyByCategories`, data)
};
export const deleteProductSchedule = (data) => {
    return middlewareEncryption(`/api/product/deleteProductSchedule`, data)
};
export const deleteMultipleSessions = (data) => {
    return middlewareEncryption(`/api/users/deleteMultipleSessions`, data)
};

export const addVisitingReport = (data) => {
    return middlewareEncryption("/api/affiliation/addVisitingReport", data)
};

export const getAllVisitingReport = () => {
    return middlewareDecryption(`/api/affiliation/getAllVisitingReport`);
};

export const updateVisitingReport = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateVisitingReport/${id}`, data)
};

export const getYtdPolicyCount = () => {
    return middlewareDecryption(`/api/sales/getYtdPolicyCount`);
};
export const getMtdDealersPolicyCount = () => {
    // return middlewareDecryption(`/api/sales/getMtdDealersPolicyCount`);
    return {};
};
export const searchPolicy = (data, param) => {
    return middlewareEncryption(`/api/partnership/getSearchDocumentByRole/${param}`, data);
};
export const getAllZm = () => {
    return middlewareDecryption(`/api/affiliation/getAllZm`)
};

export const getReportByCompanyId = (data) => {
    return middlewareEncryption("/api/dealership/getReportByCompanyId", data)
};

export const getTCReportByCompanyId = (data) => {
    return middlewareEncryption("/api/partnership/getTCReportByCompanyId", data)
};
export const getMISFinanceReport = (data) => {
    return middlewareEncryption("/api/sales/getMisFinanceReport", data)
};
export const getMISFinanceInvoiceReport = (data) => {
    return middlewareEncryption("/api/sales/getInvoiceReport", data)
};
export const getBCSyncReportSP = async (data) => {
    const token = localStorage.getItem("token");
    const headers = {
        'Authorization': token,
        'Content-Type': 'application/json'
    };
    const payload = {
        yek_ku76H6felco7: "#$x82kc6&m*E",
        ...data,
    };
    return axios.post(`${process.env.REACT_APP_SERVER_URL}/api/admin/getBCSyncReportSP`, payload, { headers });
};
export const getPlanWiseReport = (data) => {
    return middlewareEncryption("/api/sales/getPlanWiseReport", data)
};

export const getmMasterCount = () => {
    return middlewareDecryption(`/api/dealership/getmMasterCount`)
};

export const getDealerMasterCount = (id) => {
    return middlewareDecryption(`/api/dealership/getDealerMasterCount/${id}`)
    // return middlewareDecryption(`/api/dealership/getDealerMasterCount/12999`)
};

export const getActiveFuel = () => {
    return middlewareDecryption(`/api/affiliation/getActiveFuel`)
};
export const getActiveTransmission = () => {
    return middlewareDecryption(`/api/affiliation/getActiveTransmission`)
};
export const addOrUpdateDealerProductPreference = (id, data) => {
    return middlewareEncryption(`/api/dealership/addOrUpdateDealerProductPreference/${id}`, data)
};
export const getDmsAllowCompanyOnly = () => {
    return middlewareEncryption(`/api/affiliation/getDmsAllowCompanyOnly`)
};


export const downloadPolicyCertificate = (id) => {
    // id - certificate no
    return middlewareDecryption(`/api/partnership/generateDocumentCertificate/${id}`)
};

export const downloadCashifyCOA = (policyno) => {
    console.log("middlewareEncryption", policyno)
    return middlewareEncryption("/api/partnership/downloadCashifyCoa", { "policy_no": policyno })
};

// export const  = (id) => {    
//     // id - certificate no
//     return middlewareDecryption(`/api/partnership/downloadCashifyCoa/${id}`)
// };

export const downloadPolicyInvoice = (id) => {
    // id - Invoice no

    return middlewareDecryption(`/api/dealership/downloadPolicyInvoice/${id}`)
};

export const downloadInvoice = (id) => {
    // id - Invoice no

    return middlewareDecryption(`/api/partnership/generateCashifyInvoice/${id}`)
};

export const downloadInvoiceZip = (data) => {
    // data - { invoice_numbers: ["TBI/25-26/00812", "TBI/25-26/00807"] }
    return middlewareEncryption(`/api/partnership/downloadInvoiceZip`, data)
};

export const calculateBulkCommission = (data) => {
    // data - { invoice_numbers: ["TBI/25-26/00812", "TBI/25-26/00807"] }
    return middlewareEncryption(`/api/partnership/calculateBulkCommission`, data)
};

export const calculateCommissionForGroupInvoice = (data) => {
    return middlewareEncryption(`/api/partnership/calculateCommissionForGroupInvoice`, data)
};

export const getUserWalletCreditData = (id) => {
    return middlewareDecryption(`/api/affiliation/getUserWalletCreditData/${id}`,)
};

export const checkLowWalletBalance = (id) => {
    return middlewareDecryption(`/api/dealership/checkLowWalletBalanceAlert/${id}`)
};

export const getAllDealerWalletUpdateHistory = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/dealership/getAllDealerWalletUpdateHistory`, data)
};

// export const addOrUpdateDealerProductPreference = (id, data) => {
//     return middlewareEncryption(`/api/dealership/getAllDealerWalletUpdateHistory/${id}`, data)
// };

// export const getAllPortalOtp = ( page, rowsPerPage, columnFilters) => {
//     const data = createFilterData( columnFilters, page, rowsPerPage);

//     return middlewareEncryption(`/api/users/getAllPortalOtp/`,data)
// };

export const getAllPortalOtp = (payload, page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const combinedData = { ...payload, ...data, searchText, sorting };
    return middlewareEncryption(`/api/users/getAllPortalOtp/`, combinedData);
};

export const getAllSecondaryDealerCode = () => {
    return middlewareEncryption(`/api/dealership/getAllSecondaryDealerCode`)
};
export const addSecondaryDealerCode = (data) => {
    return middlewareEncryption(`/api/dealership/addSecondaryDealerCode`, data)
};

export const creatNewGeoCover = (data) => {
    return middlewareEncryption("/api/masters/creatNewGeoCover", data)
};
//Masters
//Types
// export const getAllTypes = (page, rowsPerPage, searchText, columnFilters, sorting) => {
//     const data = createFilterData(columnFilters, page, rowsPerPage);
//     return middlewareEncryption(`/api/affiliation/types`, data)
// };
// export const getAllTypes = () => {
//     return middlewareDecryption(`/api/affiliation/types`)
// };

export const getAllTypes = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);

    return middlewareEncryption("/api/affiliation/types", data)
};
// export const getAllCities = (page, rowsPerPage, searchText, columnFilters, sorting) => {
//     const data = createFilterData(columnFilters, page, rowsPerPage);

//     return middlewareEncryption("/api/affiliation/getcity", data)
// };
export const getAllZone = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    let data = createFilterData(columnFilters, page, rowsPerPage);
    const role = getFromLocalStorage("ROLE");
    if (role.key === 'DEALERSHIP_MANAGER') {
        data["is_active"] = true;
    }
    return middlewareEncryption("/api/affiliation/zones", data)
};
export const getAllCancellationReason = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption("/api/partnership/getAllCancellationReasons", data)
};

export const getAllNomineeRelation = () => {
    return middlewareDecryption(`/api/affiliation/getAllNomineeRelation`)
};
export const createNewType = (data) => {
    return middlewareEncryption("/api/affiliation/createType", data)
};
export const createMasterCity = (data) => {
    return middlewareEncryption("/api/affiliation/saveMasterCity", data)
};
export const createNewZone = (data) => {
    return middlewareEncryption("/api/affiliation/createZone", data)
};
export const addNewCancelReason = (data) => {
    return middlewareEncryption("/api/partnership/addCancellationReasons", data)
};
export const deleteType = (id) => {
    const token = localStorage.getItem("token");
    const headers = { 'Authorization': token };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteType/${id}`, { headers });
};
export const editTypes = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateType/${id}`, data)
};
export const editCities = (id, data) => {
    console.log(data, 'payload-data')
    return middlewareEncryption(`/api/affiliation/updateCity/${id}`, data)
};
export const editZone = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateZone/${id}`, data)
};

export const updatePincode = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updatePincode/${id}`, data)
};

export const editReason = (id, data) => {
    return middlewareEncryption(`/api/partnership/updateReason/${id}`, data)
};
export const editNomineeRelation = (id, data) => {
    return middlewareEncryption(`/api/affiliation/deleteNomineeRelation/${id}`, data)
};
export const editSalutation = (id, data) => {
    console.log("thi si sid and data", id, data)
    return middlewareEncryption(`/api/affiliation/deleteSalutation/${id}`, data)
};
export const getActiveTypes = () => {
    return middlewareDecryption(`/api/affiliation/activeTypes`)
};

export const getAllGender = () => {
    return middlewareDecryption(`/api/affiliation/getAllGender`)
};
export const saveGender = (data) => {
    return middlewareEncryption("/api/affiliation/saveGender", data)
};
export const saveNomineeRelation = (data) => {
    return middlewareEncryption("/api/affiliation/saveNomineeRelation", data)
};
export const saveSalutation = (data) => {
    return middlewareEncryption("/api/affiliation/saveSalutation", data)
};
export const getAllSalutation = () => {
    return middlewareDecryption(`/api/affiliation/getAllSalutation`)
};
// export const getAllNomineeRelation = () => {
//     return middlewareDecryption(`/api/affiliation/getAllNomineeRelation`)
// };
export const getAllCompanyHasNomineeRelation = () => {
    return middlewareDecryption(`/api/affiliation/getAllCompanyHasNomineeRelation`)
};
export const getAllCompanyHasSalutation = () => {
    return middlewareDecryption(`/api/affiliation/getAllCompanyHasSalutation`)
};
export const saveCompanyHasSalutation = (data) => {
    return middlewareEncryption("/api/affiliation/saveCompanyHasSalutation", data)
};
export const saveCompanyHasNomineeRelation = (data) => {
    return middlewareEncryption("/api/affiliation/saveCompanyHasNomineeRelation", data)
};
export const updateCompanyHasNomineeRelationStatus = (id, data) => {
    return middlewareEncryption(`/api/affiliation/deleteCompanyHasNomineeRelation/${id}`, data);
};
export const updateCompanyHasSalutationStatus = (id, data) => {
    return middlewareEncryption(`/api/affiliation/deleteCompanyHasSalutation/${id}`, data);
};
export const updateGenderStatus = (id, data) => {
    return middlewareEncryption(`/api/affiliation/deleteGender/${id}`, data);
};
export const getTitleByGenderAndCompany = (data) => {
    return middlewareEncryption(`/api/affiliation/getTitleByGenderAndCompany`, data);
};
export const getNomineeRelationByCompany = (data) => {
    return middlewareEncryption(`/api/affiliation/getNomineeRelationByCompany`, data);
};
export const getTitleByNomineeRelationAndCompany = (data) => {
    return middlewareEncryption(`/api/affiliation/getTitleByNomineeRelationAndCompany`, data);
};

//Category
export const getAllMasterCategories = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/categories`, data)
};
export const createNewCategory = (data) => {
    return middlewareEncryption("/api/affiliation/createCategory", data)
};
export const getActiveCategoryList = () => {
    return middlewareDecryption(`/api/affiliation/activeCategories`)
};
export const editMasterCategory = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateCategory/${id}`, data)
};
export const deleteMasterCategory = (id) => {
    const token = localStorage.getItem("token");
    const headers = { 'Authorization': token };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteCategory/${id}`, { headers });
};
//Service Type
export const getAllServiceTypes = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/serviceTypes`, data)
};
export const createNewServiceType = (data) => {
    return middlewareEncryption("/api/affiliation/createServiceType", data)
};
export const deleteServiceType = (id) => {
    const token = localStorage.getItem("token");
    const headers = { 'Authorization': token };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteServiceType/${id}`, { headers });
};
export const editServiceTypes = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateServiceType/${id}`, data)
};
export const getActiveServiceTypes = () => {
    return middlewareDecryption(`/api/affiliation/activeServiceTypes`)
};
export const getServiceTypeById = (id) => {
    return middlewareDecryption(`/api/affiliation/serviceTypeById/${id}`);
};
//Service
export const getAllServices = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/service`, data)
};

export const getAllMainService = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/mainService`, data)
};

export const createNewService = (data) => {
    return middlewareEncryption("/api/affiliation/createService", data)
};

export const createNewMainService = (data) => {
    return middlewareEncryption("/api/affiliation/createMainService", data)
};

export const deleteService = (id) => {
    const token = localStorage.getItem("token");
    const headers = { 'Authorization': token };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteService/${id}`, { headers });
};
export const editService = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateService/${id}`, data)
};
//Geographical Cover
export const getAllGeographicalCoverDetails = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/geographicalCovers`, data)
};
export const createNewGeographicalCover = (data) => {
    return middlewareEncryption("/api/affiliation/createGeographicalCover", data)
};
export const deleteGeographicalCover = (id) => {
    const token = localStorage.getItem("token");
    const headers = { 'Authorization': token };
    return axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/affiliation/deleteGeographicalCover/${id}`, { headers });
};
export const editGeographicalCoverDetails = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateGeographicalCover/${id}`, data)
};
export const getActiveGeographicalCover = () => {
    return middlewareDecryption(`/api/affiliation/activeGeographicalCover`)
};
//Country
export const getAllCountryDetails = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/countries`, data);
};
export const createNewCountry = (data) => {
    return middlewareEncryption("/api/affiliation/createCountry", data)
};
export const editCountryDetails = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateCountry/${id}`, data)
};
// Masters end
//Consolidator
export const createNewConsolidator = (data) => {
    return middlewareEncryption("/api/consolidator/addConsolidator", data)
};
export const getCnListing = (data) => {
    return middlewareEncryption("/api/consolidator/getCnListing", data);
}
export const syncCnToBc = (data) => {
    return middlewareEncryption("/api/consolidator/syncCnToBc", data);
}
export const getAllConsolidatorList = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption("/api/consolidator/getAllConsolidators", data)
};
export const editConsolidator = (id, data) => {
    return middlewareEncryption(`/api/consolidator/updateConsolidator/${id}`, data)
};
export const getConsolidatorDataByRole = (data) => {
    return middlewareEncryption(`/api/consolidator/getProcessConsolidatorCommission`, data)
};
export const getConsolidatorById = (id) => {
    return middlewareDecryption(`/api/consolidator/getConsolidatorById/${id}`);
};
export const getActiveService = (data) => {
    return middlewareEncryption(`/api/affiliation/activeService`, data)
};
export const getGeographicalCover = () => {
    return middlewareDecryption(`/api/affiliation/activeGeographicalCover`)
};
export const getTypes = () => {
    return middlewareDecryption(`/api/affiliation/activeTypes`)
}
export const getAddonTypes = () => {
    return middlewareDecryption(`/api/affiliation/getAddonType`)
}
export const getAllCurrency = () => {
    return middlewareDecryption(`/api/affiliation/getAllCurrency`)
}
export const createNewPartnership = (data) => {
    return middlewareEncryption("/api/partnership/addPartnership", data)
};
export const getAllPartnershipList = (page, rowsPerPage, searchText, columnFilters, sorting, is_active) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const COMPANY_MODULE = getFromLocalStorage("user")?.companyInfo?.module_id;
    data.module_id = COMPANY_MODULE;
    const role_alias = getFromLocalStorage("ROLE");
    data.role_alias = role_alias?.alias ? role_alias?.alias : '';
    if (is_active !== undefined) {
        data.is_active = is_active;
    }
    return middlewareEncryption("/api/partnership/getAllPartners", data)
};
export const getAllPartnershipListBYRole = (page, rowsPerPage, searchText, columnFilters, sorting, explicitRoleId, is_active) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = explicitRoleId || (ROLE?.role_id ? ROLE.role_id : '');
    const data = createFilterData(columnFilters, page, rowsPerPage);

    if (is_active !== undefined) {
        data.is_active = is_active;
    }
    return middlewareEncryption("/api/partnership/getPartnershipsByRole/" + role_id, data)
};
export const getCommissionHistoryByPartnershipId = (id) => {
    return middlewareDecryption(`/api/partnership/getCommissionHistoryByPartnership/${id}`);
};
export const getAllPartnershipListBYRoleWithoutPagination = (walletType) => {
    console.log("walletType called", walletType);
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    const data = {
        walletType: walletType
    };
    return middlewareEncryption("/api/partnership/getPartnershipsByRoleWithoutPagination/" + role_id, data)
};

export const getSmOldBpList = (sm_user_id) => {
    return middlewareEncryption("/api/partnership/getSmOldBpList", { sm_user_id });
};

export const getActiveConsolidators = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const payload = {
        is_active: true
    };
    const data = createFilterData(columnFilters, page, rowsPerPage);
    const combinedData = { ...payload, ...data };
    return middlewareEncryption("/api/consolidator/getAllConsolidators", combinedData)
};
export const getAllConsolidators = () => {

    return middlewareDecryption("/api/consolidator/getConsolidator")
};

export const syncDocumentsToBc = (data) => {
    return middlewareEncryption("/api/consolidator/syncDocumentsToBc", data);
}

export const downloadAggregatorLedger = (data) => {
    return middlewareEncryption("/api/consolidator/downloadConsolidatorLedger", data);
}
export const generateReconcileReport = (data) => {
    return middlewareEncryption("/api/affiliation/generateReconciliationReport", data);
};

export const getReconcileReportLogs = (data) => {
    console.log("getReconcileReportLogs called with data:", data);
    return middlewareEncryption("/api/affiliation/getReconciliationReportLogs", data);
}
export const downloadReconciliationReport = (data) => {
    console.log("getReconcileReportLogs called with data:", data);
    return middlewareEncryption("/api/affiliation/downloadReconciliationReport", data);
}


// user

export const createNewUsers = (data) => {
    return middlewareEncryption("/api/admin/createUser", data)
};

export const createCashifyNewUsers = (data) => {
    return middlewareEncryption("/api/admin/createCashifyUser", data)
};

export const getPartnerShipByConsolidator = (data) => {
    return middlewareEncryption("/api/consolidator/getPartnerShipByConsolidator", data)
};
export const getPartnershipById = (id) => {
    return middlewareDecryption(`/api/partnership/getPartnerById/${id}`);
};
export const getKycDetailsByPartnershipId = (id) => {
    return middlewareDecryption(`/api/partnership/getKycDetailsByPartnershipId/${id}`);
};
export const getBpGstVerificationLisitng = (data) => {
    return middlewareEncryption(`/api/dealership/getGstVerificationHistory`, data);
}
// BC Sync API - TODO: update endpoint once backend is ready
export const syncBcPolicy = (data) => {
    return middlewareEncryption(`/api/payment/externalCashifySync/`, data);
};

//Fetch Plans
export const getAllActivePlans = (data) => {
    return middlewareEncryption("/api/affiliation/fetchEligiblePlan", data)
};
export const getAllActivePlansList = () => {
    return middlewareDecryption("/api/affiliation/activePlans")
};
export const getPlanByCompanyId = (data) => {
    return middlewareEncryption(`/api/affiliation/getPlanByCompanyId`, data);
};

export const getActivePlansByCompanyId = (data) => {
    return middlewareEncryption(`/api/affiliation/getActivePlansByCompanyId`, data);
};

// export const getAllDocuments = (page, rowsPerPage, searchText, columnFilters, sorting=[]) => {
//     return middlewareEncryption(`/api/partnership/getDocuments`);
// };
export const getAllDocumentsByRole = (id, page, rowsPerPage, searchText, columnFilters, sorting = []) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/partnership/getDocumentByRole/${id}`, data);
};
export const getInvoiceDocumentByRoleNew = (id, page, rowsPerPage, searchText, columnFilters, sorting = [], startDate, endDate, isFullData = false, download = false) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    data.start_date = startDate;
    data.end_date = endDate;
    if (download) data.download = true;
    console.log("getInvoiceDocumentByRoleNew-data", data, id);
    if (isFullData) {
        const newData = {
            start_date: startDate,
            end_date: endDate,
            download: data.download
        }
        return middlewareEncryption(`/api/partnership/getInvoiceDocumentByRoleNew/${id}`, newData);
    }
    return middlewareEncryption(`/api/partnership/getInvoiceDocumentByRoleNew/${id}`, data);
};

export const getInvoiceDocumentByRole = (id, page, rowsPerPage, searchText, columnFilters, sorting = [], startDate, endDate, isFullData = false, download = false) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    data.start_date = startDate;
    data.end_date = endDate;
    if (download) data.download = true;
    console.log("getInvoiceDocumentByRole-data", data, id);
    if (isFullData) {
        const newData = {
            start_date: startDate,
            end_date: endDate,
            download: data.download
        }
        return middlewareEncryption(`/api/partnership/getInvoiceDocumentByRole/${id}`, newData);
    }
    return middlewareEncryption(`/api/partnership/getInvoiceDocumentByRole/${id}`, data);
};

export const invoiceReportDownload = (startDate, endDate, documentType, partnership_id, role_id, isBulk, isClaim, isCustomerInvoice) => {

    const data = { startDate, endDate, documentType, partnership_id, role_id, isBulk, isClaim, isCustomerInvoice };
    console.log(data, 'data')
    return middlewareEncryption("/api/partnership/downloadInvoiceListing", data);
};

export const getBulkInvoiceDocumentByRole = (id, page, rowsPerPage, searchText, columnFilters, sorting = []) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/partnership/getBulkInvoiceDocumentByRole/${id}`, data);
};

export const getBulkInvoiceDocumentByRoleNew = (id, page, rowsPerPage, searchText, columnFilters, sorting = [], startDate, endDate,  walletType = "", download = false) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    data.startDate = startDate
    data.endDate = endDate
    data.download = download;
    if (walletType) {
        data.walletType = walletType;
    }
    console.log("SENDING TO getBulkInvoiceDocumentByRoleNew", data);
    return middlewareEncryption(`/api/partnership/getBulkInvoiceDocumentByRoleNew/${id}`, data);
};

// export const getBulkClaimInvoiceDocumentByRole = (id, page, rowsPerPage, searchText, columnFilters, sorting=[]) => {
export const getBulkClaimInvoiceDocumentByRole = (id, page, rowsPerPage, searchText, columnFilters, sorting = []) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/partnership/getBulkClaimInvoiceDocumentByRole/${id}`, data);
};

export const getBulkClaimInvoiceDocumentByRoleNew = (id, page, rowsPerPage, searchText, columnFilters, sorting = [], isCpg = false, startDate, endDate, download = false) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    if (isCpg) {
        data.isCpg = true;
    }
    data.startDate = startDate;
    data.endDate = endDate;
    if (download) data.download = true;
    return middlewareEncryption(`/api/partnership/getBulkClaimInvoiceDocumentByRoleNew/${id}`, data);
};

export const getDocumentsAndCalculationOfInvoice = (id, data) => {
    return middlewareEncryption(`/api/partnership/getDocumentsAndCalculationOfInvoice/${id}`, data);
};

// export const getCustomerInvoiceDocumentByRole = (id, page, rowsPerPage, searchText, columnFilters, sorting=[]) => {
export const getCustomerInvoiceDocumentByRole = (id, page, rowsPerPage, searchText, columnFilters, sorting = [], startDate, endDate, download = false) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    data.startDate = startDate;
    data.endDate = endDate;
    if (download) data.download = true;
    return middlewareEncryption(`/api/partnership/getCustomerInvoiceDocumentByRole/${id}`, data);
};

export const getClaimInvoiceDocumentByRole = (id, page, rowsPerPage, searchText, columnFilters, sorting = [], startDate, endDate, download = false) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    data.startDate = startDate;
    data.endDate = endDate;
    if (download) data.download = true;
    return middlewareEncryption(`/api/partnership/getClaimInvoiceDocumentByRole/${id}`, data);
};

export const getInvoiceDocumentByPartnershipId = (id) => {
    return middlewareEncryption(`/api/partnership/getInvoiceDocumentDetailsBypartnershipId/${id}`);
};
export const getMasterCountries = () => {
    return middlewareDecryption(`/api/affiliation/masterCountries`)
};
export const geographicalCountry = (id) => {
    return middlewareDecryption(`/api/affiliation/countryListByGeoCoverId/${id}`)
};
export const getAllDocumentsAdmin = () => {
    return middlewareDecryption(`/api/partnership/getAllDocumentsAdmin`)
};
export const getAllCashifyDocumentData = (data) => {
    return middlewareEncryption("/api/partnership/getAllDocumentForCashifyData", data)
};
export const getCashifyTransactions = (data) => {
    return middlewareDecryption(`/api/payment/cashify-transactions?transaction_id=${data.transaction_id}&&utr_number=${data.utr_number}`)
};
export const getCashifyPolicyByTransactions = (data) => {
    return middlewareEncryption("/api/payment/cashify-policy-by-transactions", data)
};
export const getVerifyTransactions = async (data) => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: token };
    const result = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/payment/verify-payment-helper`,
        DataEncription(data),
        { headers }
    );

    if ("result" in result.data && result.data.result) {
        try {
            result.data.result = Decrypt(result.data.result);
        } catch (_e) {
            // Some environments return this payload already decrypted.
        }
    }

    return result;
};
export const getGeneratePolicyNo = async (data) => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: token };
    const result = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/payment/cashify-success`,
        // DataEncription(data),
        data,
        { headers }
    );

    if ("result" in result.data && result.data.result) {
        try {
            result.data.result = Decrypt(result.data.result);
        } catch (_e) {
            // Some environments return this payload already decrypted.
        }
    }

    return result;
};
export const activeDeactiveDocument = (id, data) => {
    return middlewareDecryption(`/api/partnership/activeDeactiveDocument ${id}`, data)
};

export const syncDocumentDataToBCByDocId = (data) => {
    return middlewareEncryption("/api/partnership/syncDocumentDataToBCByDocId", data);
}

export const crmSyncDocumentDataByDocId = (data) => {
    return middlewareEncryption("/api/partnership/crmSyncDocumentDataByDocId", data);
}

export const getDocumentById = (id) => {
    return middlewareDecryption(`/api/partnership/getDocumentById/${id}`)
};
export const getBrandByCompany = (id) => {
    return middlewareDecryption(`/api/affiliation/getBrandByCompany/${id}`)
};
export const requestCancelDocumentPolicy = (data) => {
    return middlewareEncryption(`/api/partnership/requestCancelPolicy`, data)
};
export const requestCashifyCancelPolicy = (data) => {
    return middlewareEncryption(`/api/partnership/requestCashifyCancelPolicy`, data)
};
export const validateBulkDocuments = (data) => {
    return middlewareEncryption("/api/partnership/validateBulkDocuments", data)
};
//old one for SM
export const validateBulkDocumentsV1 = (data) => {
    return middlewareEncryption("/api/partnership/v1/validateBulkDocuments", data)
};
export const punchBulkDocuments = (data) => {
    return middlewareEncryption("/api/partnership/punchBulkDocuments", data)
};
export const punchMultiProposerBulkDocuments = (data) => {
    return middlewareEncryption("/api/partnership/v1/punchBulkDocuments", data)
};
export const getAllTcDocumentData = (data) => {
    return middlewareEncryption("/api/partnership/getAllTcDocumentData", data)
};
export const getBpKycMisReport = (data) => {
    data.startDate = data.start_date;
    data.endDate = data.end_date;
    return middlewareEncryption("/api/dealership/getBpKycMisReport", data)
};

export const fetchCommissionCalculation = (data) => {
    return middlewareEncryption(`/api/partnership/calculateCommission`, data)
};

export const getCommission = (data) => {
    return middlewareEncryption(`/api/partnership/getCommission`, data);
}
export const processCommission = (data) => {
    return middlewareEncryption(`/api/partnership/processCommission`, data)
};

export const processCommissionForGroupInvoice = (data) => {
    return middlewareEncryption(`/api/partnership/processCommissionForGroupInvoice`, data)
};

export const downloadCI = (id) => {
    return middlewareDecryption(`/api/partnership/reGenerateCommissionInvoicePDF/${id}`)
};

export const customerPayment = (data) => {
    return middlewareEncryption(`/api/partnership/sendPaymentLink`, data)
};

export const sendInvoiceLink = (data) => {
    return middlewareEncryption(`/api/partnership/sendInvoicePaymentLink`, data)
};

export const customerPaymentByCpg = (data) => {
    return middlewareEncryption(`/api/partnership/sendPaymentLinkToCustomer`, data)
};
export const initiateCustomerRefundPayment = (data) => {
    return middlewareEncryption(`/api/payment/initiateRefund`, data)
};
export const initiateCommissionRefund = (data) => {
    return middlewareEncryption(`/api/payment/initiateCommissionRefund`, data)
};
export const cashifyPayment = (data) => {
    return middlewareEncryption(`/api/partnership/cashifyPayment`, data)
};
export const cashifyIMEINumberValidation = (data) => {
    return middlewareEncryption(`/api/partnership/cashifyIMEINumberValidation`, data)
};
export const updatePartnership = (id, data) => {
    return middlewareEncryption(`/api/partnership/updatePartnership/${id}`, data)
};
export const getSalesManagerList = () => {
    return middlewareEncryption(`/api/dealership/getSalesManagerList`)
};
export const getMisListByRole = (data) => {
    return middlewareEncryption(`/api/sales/getUsersListByRole`, data)
};
export const getSmMisReport = (data) => {
    return middlewareEncryption(`/api/sales/getSmMisReport`, data)
};
export const getMisReportByRole = (data) => {
    return middlewareEncryption(`/api/sales/getMisReportByRole`, data)
};

export const getCashifyMisReport = () => {
    return middlewareEncryption(`/api/dealership/getCashifyMis`);
};
export const getCashifySalesReport = (data) => {
    return middlewareEncryption(`/api/partnership/getCashifyBpReport`, data);
};
// export const scanmeLanding = (id, data) => {
//     return middlewareDecryption(`/api/scanme/getDetailsByPolicyId/${id}`, data)
// };
export const scanmeLanding = (id, data) => {
    return middlewareDecryptionWithoutToken(`/api/scanme/getDetailsByDocumentId/${id}`, data)
};


export const getCountriesByCoverId = (id) => {
    return middlewareDecryptionWithoutToken(`/api/scanme/getCountriesByCoverId/${id}`)
};

// export const saveScanmedata = async (data) => {
//     return middlewareEncryption(`/api/scanme/scanme-landing`, data)
//     // result = await axios.post(`${process.env.REACT_APP_SERVER_URL}${api}`)
// };
export const createDocumentForCPGQuotation = (data) => {
    return middlewareEncryption(`/api/payment/createDocumentForCPGQuotation`, data);
};

export const getAllQuotationList = (page, rowsPerPage, searchText, columnFilters, sorting, role_id) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/partnership/getQuotations/${role_id}`, data)
};
export const getQuotationById = (id) => {
    return middlewareDecryption(`/api/partnership/getQuotationById/${id}`)
};
export const saveDocumentAsQuotation = (data) => {
    return middlewareEncryption(`/api/partnership/saveDocumentAsQuotation`, data)
};
export const updateQuotationCpgPayload = (data) => {
    return middlewareEncryption(`/api/partnership/updateQuotationCpgPayload`, data)
};
export const savePremiumCalculatorEnquiry = (data) => {
    return middlewareEncryption(`/api/partnership/savePremiumCalculatorEnquiry`, data)
};
export const updateQuotation = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateQuotation/${id}`, { data })
}
export const updatePlanProduct = (id, data) => {
    // return middlewareEncryption("/api/product/addProduct", data)
    return middlewareEncryption(`/api/affiliation/updatePlanData`, data)
};
export const shareQuotation = (data) => {
    return middlewareEncryption(`/api/partnership/shareQuotation`, data)
}
export const shareQuotationWithCpg = (data) => {
    return middlewareEncryption(`/api/partnership/shareQuotationWithCpg`, data)
}
export const getModules = () => {
    return middlewareEncryption(`/api/affiliation/getModules/`)
};
export const fetchProductPricing = (data) => {
    return middlewareEncryption(`/api/partnership/fetchProductPricing`, data);
};

//Commission module

export const verifyInvoiceOtp = (data) => {
    return middlewareEncryption(`/api/partnership/verifyInvoiceOtp`, data)
}

export const verifyGroupInvoiceOtp = (data) => {
    return middlewareEncryption(`/api/partnership/verifyGroupInvoiceOtp`, data)
}

export const verifyInvoiceOtpNormalWallet = (data) => {
    return middlewareEncryption(`/api/partnership/verifyInvoiceOtpNormalWallet`, data)
}
export const verifyCustomerPaymentInvoiceOtp = (data) => {
    return middlewareEncryption(`/api/partnership/verifyCustomerPaymentInvoiceOtp`, data)
}
export const sendOtpForInvoiceVerification = (data) => {
    return middlewareEncryption(`/api/partnership/sendOtpForInvoiceVerification`, data)
}
export const checkCommissionInvoice = (data) => {
    return middlewareEncryption(`/api/partnership/checkCommissionInvoice`, data)
}
export const getAllPolicyData = (payload) => {
    return middlewareEncryption(`/api/nyom/getPolicyData`, payload)
};
export const getPolicyData = (code) => {
    return middlewareEncryption(`/api/nyom/getPolicyData/${code}`)
};
export const getAllCashifyPolicy = (page = 0, rowsPerPage = 10, searchText = "", columnFilters = [], sorting = []) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    const data = createFilterData(columnFilters, page, rowsPerPage);
    if (data.bcFlag !== undefined) {
        data.bcFlag = data.bcFlag[0] === 'true';
    }
    return middlewareEncryption(`/api/partnership/getCashifyPolicyDetailsByRole/` + role_id, data);

};

export const saveScanmedata = (data) => {
    return middlewareEncryption(`/api/scanme/scanme-landing`, data)
};

// SAML
export const loginWithSAML = async () => {
    window.location.href = `${process.env.REACT_APP_SERVER_URL}/auth/saml`
    // window.location.href = `https://ts-stage-api.europassistance.in/auth/saml`
};
export const getCommissionByRole = (id, page, rowsPerPage, searchText, columnFilters, sorting = []) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/partnership/getCommissiionByRole/${id}`, data);
};

export const getCnForBp = (id, page, rowsPerPage, searchText, columnFilters, sorting = []) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/partnership/getBpCNDetails`, data);
};

export const getUsersDetailsByRoleNew = (page, rowsPerPage, searchText, columnFilters, sorting) => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    const COMPANY_MODULE = getFromLocalStorage("user")?.companyInfo?.module_id;

    if (!role_id) {
        return toast.error('Role missing in route');
    }

    // const queryParameters = new URLSearchParams(window.location.search)

    let dataType = 1;
    // Get the current URL from the browser
    const currentURL = window.location.href;
    // Check if the URL contains '/dealership/users' or '/dealership/company' and set dataType accordingly
    if (currentURL.includes('/affiliations/partnership/users')) {
        dataType = 3;
    } else if (currentURL.includes('/affiliations/companies/users')) {
        dataType = 2;
    }
    const data = createFilterData(columnFilters, page, rowsPerPage);
    data.adminFLAG = dataType;
    data.module_id = COMPANY_MODULE
    return middlewareEncryption(`/api/dealership/getUsersDetailsByRoleNew/${role_id}`, data)
};

export const getUsersDetailsByuserId = () => {
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    if (!role_id) {
        return toast.error('Role missing in route');
    }
    const data = createFilterData([], 0, 100);
    data.adminFLAG = 3;
    return middlewareEncryption(`/api/dealership/getUsersDetailsByRoleNew/${role_id}`, data)
};

export const getAllUsersDetailsByRole = () => {

    let body = {};
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_id = ROLE?.role_id ? ROLE.role_id : '';
    if (!role_id) {
        return toast.error('Role missing in route');
    }

    let dataType = 1;
    const currentURL = window.location.href;
    if (currentURL.includes('/affiliations/partnership/users')) {
        dataType = 3;
    } else if (currentURL.includes('/affiliations/companies/users')) {
        dataType = 2;
    }

    body.adminFLAG = dataType;
    return middlewareEncryption(`/api/dealership/getAllUsersDetailsByRole/${role_id}`, body);

}

export const updatePass = (id) => {
    return middlewareEncryption(`/api/admin/updatePass/${id}`)
};

export const getAllPincode = (data) => {
    return middlewareEncryption(`/api/affiliation/getpincode`, data);
};
export const getAllMasterCities = (data) => {
    return middlewareEncryption(`/api/affiliation/getcity`, data);
};

export const fetchState = (data) => {
    return middlewareDecryption(`/api/affiliation/fetchState`);
}

export const fetchCityList = (data) => {
    return middlewareEncryption(`/api/affiliation/fetchCityList`, data);
}

export const savePincode = (data) => {
    return middlewareEncryption(`/api/affiliation/savePincode`, data);
}
//Assign plan to partner

export const assignPlansToPartners = (data) => {
    return middlewareEncryption("/api/affiliation/assignPlanToPartner", data)
};

export const deAssignPlansFromPartners = (id, data) => {
    return middlewareEncryption(`/api/affiliation/deAssignPlanToPartner/${id}`, data)
};

export const getAssignedPlansByRoleWithoutPaginationBulk = (id, data) => {
    return middlewareEncryption(`/api/affiliation/getAssignedPlansByRoleBulk/${id}`, data);
};

export const deleteAssignedPlan = (id) => {
    return middlewareEncryption(`/api/affiliation/deleteAssignedPlan/${id}`, {});
};


export const updateAssignedPlan = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateAssignedPlan/${id}`, { data });
};
export const bulkUpdateAssignedPlan = (id, data) => {
    return middlewareEncryption(`/api/affiliation/bulkUpdateAssignedPlan/${id}`, { data });
};
export const resyncBulkExternalSync = (id, data) => {
    return middlewareEncryption(`/api/partnership/resyncBulkExternalSync`, { data });
};
export const resyncExternalSyncFromFE = (id, data) => {
    return middlewareEncryption(`/api/partnership/resyncExternalSyncFromFE`, { data });
};
export const resyncBulkExternalSyncFromFE = (id, data) => {
    return middlewareEncryption(`/api/partnership/resyncBulkExternalSyncFromFE`, { data });
};
export const getActiveTypeByCompanyId = (id) => {
    return middlewareDecryption(`/api/affiliation/getTypeByCompanyId/${id}`)
};
export const getQuatationById = (id) => {
    return middlewareDecryption(`/api/affiliation/getQuotationDetailsById/${id}`)
};
export const updateQuatationById = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateQuotationDetailsById/${id}`, data);
};

// Verify traveller DOB before exposing quotation details
export const verifyTravellerDob = (quotationId, dob) => {
    console.log("verifying dob", quotationId, dob);
    // POST to backend verify endpoint. Backend should return { valid: true } in result
    return middlewareEncryption(`/api/affiliation/verifyTravellerDob/${quotationId}`, { dob });
};

export const getCompanyWithTypes = (page, rowsPerPage, columnFilters) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getCompanyWithTypes`, data);
};
export const creatCompanyWithType = (data) => {
    return middlewareEncryption("/api/affiliation/saveCompanyWithTypes", data)
};
export const updateCompanyWithTypes = (data) => {
    return middlewareEncryption("/api/affiliation/updateCompanyWithTypes", data)
};
export const updateCompanyWithTypesStatus = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateCompanyWithTypesStatus/${id}`, data);
};
export const getCompanyAndTypesWithGeo = (page, rowsPerPage, columnFilters) => {
    const data = createFilterData(columnFilters, page, rowsPerPage);
    return middlewareEncryption(`/api/affiliation/getCompanyAndTypesWithGeo`, data);
};
export const createCompanyAndTypesWithGeo = (data) => {
    return middlewareEncryption("/api/affiliation/saveCompanyAndTypesWithGeo", data)
};
export const updateCompanyAndTypesWithGeo = (data) => {
    return middlewareEncryption("/api/affiliation/updateCompanyAndTypesWithGeo", data)
};
export const updateCompanyAndTypesWithGeoStatus = (id, data) => {
    return middlewareEncryption(`/api/affiliation/updateCompanyAndTypesWithGeoStatus/${id}`, data);
};
export const getActiveGeographicalCoverByType = (id) => {
    return middlewareDecryption(`/api/affiliation/getGeographicalCoverByTypeId/${id}`)
};
export const getMultiProposerCheck = () => {
    return middlewareDecryption(`/api/affiliation/getMultiProposerCheck`)
};
export const getActiveGeographicalCoverByTypeAndCompany = (data) => {
    return middlewareEncryption("/api/affiliation/getGeographicalCoverByTypeIdAndCompanyId", data)
};
export const getStatusGSTRegistered = (id) => {
    return middlewareDecryption(`/api/partnership/checkDocumentDetails/${id}`,)
};
export const getDocumentsByConsolidatorCommission = (data) => {
    return middlewareEncryption("/api/consolidator/getDocumentsForCommission", data);
}
export const downloadDocumentCertificate = (documentNo) => {
    return middlewareEncryption(`/api/partnership/downloadDocumentCertificate`, { "document_unique_code": documentNo })
};

export const downloadCoaZip = (data) => {
    return middlewareEncryption(`/api/partnership/downloadCoaZip`, data)
}

export const reGenerateCNforCommision = async (data) => {
    return await middlewareEncryption('/api/partnership/reGenerateCNforCommision', data);
};

export const getPaymentTransactions = (params) => {
    const queryString = new URLSearchParams(
        Object.entries(params).filter(([_, v]) => v !== undefined && v !== null && v !== "")
    ).toString();
    const url = `/api/v2/payment/transactions${queryString ? '?' + queryString : ''}`;
    return middlewareDecryption(url);
}

export const verifyPaymentHelper = async (data) => {
    const token = localStorage.getItem("token");
    const headers = { 'Authorization': token };
    // The backend expects an encrypted request, but sends an unencrypted response for this specific endpoint.
    let result = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/payment/verify-payment-helper`, DataEncription(data), { headers });
    return result;
}

export const handleCustomerPaymentSuccess = async (data) => {
    const token = localStorage.getItem("token");
    const headers = { 'Authorization': token };
    // Sending raw data because customerPayment-success is in EXCLUDED_ROUTES (backend)
    return axios.post(`${process.env.REACT_APP_SERVER_URL}/api/payment/customerPayment-success`, data, { headers });
}
export const uploadBulkSample = (data) => {
    const token = localStorage.getItem("token");
    const headers = { 'Authorization': token };
    return axios.post(`${process.env.REACT_APP_SERVER_URL}/api/partnership/uploadBulkSample`, data, { headers });
};

export const getBulkSample = (company_id, travel_type) => {
    return middlewareDecryption(`/api/partnership/getBulkSample/${company_id}/${travel_type}`);
};

export const getBcSalesStats = (data) => {
    return middlewareEncryption(`/api/partnership/getBcSalesStats`, data);
};

export const getMisBetaReport = (data) => {
    return middlewareEncryption(`/api/admin/getPolicyReportByRole`, data);
};

